<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="userData === undefined">
      <h4 class="alert-heading">حدث خطأ أثناء جلب بيانات المستخدم</h4>
      <div class="alert-body">
        لم يتم العثور على المستخدم اللذي طلبته .
        <b-link class="alert-link" :to="{ name: 'settings-users' }">
          عودة الى جدول المستخدمين
        </b-link>
      </div>
    </b-alert>
    <skeleton-loader v-if="loading" />
    <template v-else>
      <form-modal
        ref="UsersModal"
        :formSchema="userFormSchema"
        title="تعديل المستخدم"
        v-model="isUserModalOpen"
        @confirm="onUpdateUserconfirmed"
      />
      <form-modal
        ref="passwordModalUserLogin"
        :formSchema="changePasswordFormSchema"
        title="تغيير كلمة السر"
        v-model="changePasswordModalVisible"
        @confirm="
          onChangePasswordConfirmed($event);
          changePasswordModalVisible = false;
        "
        :BCansel="true"
      />
      <!-- First Row -->
      <b-row>
        <b-col cols="12" xl="9" lg="8" md="7">
          <user-view-user-info-card
            v-if="userData && userData.ngo"
            @changePasswordClicked="changePasswordModalVisible = true"
            @editClicked="openEditModal(userData)"
            @deleteClicked="onDelete(userData.id)"
            :user-data="userData"
          />
        </b-col>
        <b-col cols="12" md="5" xl="3" lg="4">
          <user-view-user-plan-card
            v-if="userData && userData.ngo"
            :ngo="userData.ngo"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" lg="6">
          <user-view-user-timeline-card
            style="max-height: 500px; overflow: auto"
            :items="userLog"
          />
        </b-col>
        <b-col cols="12" lg="6">
          <user-view-user-permissions-card />
        </b-col>
      </b-row>

      <!-- <invoice-list /> -->
    </template>
  </div>
</template>

<script>
import store from "@/store";
import { ref, onUnmounted, computed } from "@vue/composition-api";
import { BRow, BCol, BAlert, BLink } from "bootstrap-vue";
import userStoreModule from "../store";
import UserViewUserInfoCard from "./UserViewUserInfoCard.vue";
import UserViewUserPlanCard from "./UserViewNgoCard.vue";
import UserViewUserTimelineCard from "./UserViewUserTimelineCard.vue";
import UserViewUserPermissionsCard from "./UserViewUserPermissionsCard.vue";
import FormModal from "@/components/FormModal.vue";
import useUsersList from "../useUsersList";
import { useRouter } from "@/@core/utils/utils";
import SkeletonLoader from "@/modules/temp-ngo/components/SkeletonLoader.vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import { resolveUpdated } from "@/utils/utils";
export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    // Local Components
    UserViewUserInfoCard,
    UserViewUserPlanCard,
    UserViewUserTimelineCard,
    UserViewUserPermissionsCard,
    FormModal,
    SkeletonLoader,
    MinistryBreadcrumbs,
  },
  props: ["id"],
  methods: {
    openEditModal(userData) {
      const toUpdate = { ...userData };
      delete toUpdate.governorate;
      delete toUpdate.ministry;
      delete toUpdate.roles;
      delete toUpdate.ngoRoles;

      this.$refs.UsersModal.init({
        ...toUpdate,
        roles: userData.roles ? userData.roles.map((el) => el.id) : [],
        governorate_id: userData.governorate ? userData.governorate.id : null,
        ngo_id: userData.ngo ? userData.ngo.id : null,
      });
      this.isUserModalOpen = true;
      this.$nextTick(() => {
        this.$store.commit("ngosSelect/setOptions", [toUpdate.ngo]);
        delete toUpdate.ngo;
      });
    },

    async onUpdateUserconfirmed(form) {
      await this.updateUser(resolveUpdated(form, this.userData));
      this.isUserModalOpen = false;
      this.updateKey++;
      this.refreshUserData();
    },
  },
  setup(props) {
    const userData = ref(null);
    const userLog = ref([]);
    const isUserModalOpen = ref(false);
    const changePasswordModalVisible = ref(false);

    const USER_APP_STORE_MODULE_NAME = "Ministry/Settings/Users";
    const { router } = useRouter();

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });
    const loading = computed(() => {
      return store.getters["Ministry/Settings/Users/loading"];
    });
    const mainTitle = ref("المستخدمين");
    const breadcrumbs = ref([
      {
        text: "الإعدادات",
        to: "/ministry/settings",
      },
      {
        text: "المستخدمين",
        to: "/ministry/settings/users",
      },
    ]);
    const refreshUserData = () => {
      store
        .dispatch("Ministry/Settings/Users/fetchUser", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          userData.value = response.data.data;
          mainTitle.value = userData.value.full_name;
          breadcrumbs.value[2] = {
            text: userData.value.full_name,
            active: true,
          };
        })
        .catch(() => {
          userData.value = undefined;
        });

      store
        .dispatch("Ministry/Settings/Users/fetchUserLog", {
          id: router.currentRoute.params.id,
        })
        .then((response) => {
          userLog.value = response.data.data;
        })
        .catch(() => {
          userLog.value = undefined;
        });
    };

    const { updateUser, deleteUser, changeUserPassword } = useUsersList();
    const userFormSchema = {
      full_name: {
        component: "FormInput",
        key: "full_name",
        attrs: {
          label: "الاسم الكامل",
          rules: "required",
        },
      },
      username: {
        component: "UsernameInput",
        key: "username",
        attrs: {
          label: "اسم المستخدم",
          rules: "required",
          isMinistry: true,
        },
      },
      email: {
        component: "EmailInput",
        key: "email",
        attrs: {
          label: "البريد الإلكتروني*",
          rules: "required|email",
          isMinistry: true,
        },
      },
      mobile: {
        component: "MobileInput",
        key: "mobile",
        attrs: {
          id: "mobile-input",
          label: "رقم الموبايل*",
          rules: "required",
          isMinistry: true,
        },
      },
      phone: {
        component: "PhoneInput",
        key: "phone",
        attrs: {
          id: "phone-input",
          label: " رقم الهاتف",
          isMinistry: true,
        },
      },
      dob: {
        component: "FormMask",
        key: "dob",
        attrs: {
          label: "تاريخ الميلاد",
          options: "date",
          rules: "required",
          placeholder: "YYYY-MM-DD",
        },
      },
      ngo_id: {
        component: "FormAutocomplete",
        key: "ngo_id",
        attrs: {
          id: "ngosSelect",
          label: "المنظمة",
          ep: "v2/ministry/selects/ngos",
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          rules: "required",
          ref: "ngoAutocomplete",
        },
      },
      governorate_id: {
        component: "FormSelect",
        key: "governorate_id",
        attrs: {
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name_ar,
          id: "users_gov_manage_",
          label: "المحافظة",
          ep: "v2/ministry/selects/governorates",
          rules: "required",
        },
      },
      is_blocked: {
        component: "FormSelect",
        key: "is_blocked",
        attrs: {
          id: "is_blocked",
          label: "حساب محظور",
          rules: "required",
          reduce: (el) => el.value,
          options: [
            { label: "نعم", value: true },
            { label: "لا", value: false },
          ],
        },
      },
      is_locked: {
        component: "FormSelect",
        key: "is_locked",
        attrs: {
          id: "is_locked",
          label: "حساب مقفل",
          rules: "required",
          reduce: (el) => el.value,
          options: [
            { label: "نعم", value: true },
            { label: "لا", value: false },
          ],
        },
      },
      roles: {
        component: "FormSelect",
        key: "roles",
        attrs: {
          reduce: (x) => x.id,
          getOptionLabel: (x) => x.name,
          id: "roles-select",
          label: "الأدوار",
          ep: "v2/ministry/selects/roles?isMinistry=false",
          rules: "required",
          closeOnSelect: false,
          multiple: true,
        },
      },
      // password: {
      //   component: "GeneratePassword",
      //   key: "password",
      //   attrs: {
      //     id: "password",
      //     label: "كلمة السر ",
      //     rules: "required",
      //   },
      // },
      // password_must_change: { key: "password_must_change" },
    };
    const changePasswordFormSchema = {
      new_password: {
        component: "FormPassword",
        key: "new_password",
        attrs: {
          id: "new_password",
          label: " كلمة السر الجديدة ",
          rules: "required|min:8",
        },
      },
      new_password_confirmation: {
        component: "FormPassword",
        key: "new_password_confirmation",
        attrs: {
          id: "new_password_confirmation",
          label: "تأكيد كلمة السر ",
          rules: "required|min:8",
        },
      },
    };
    const onDelete = async (id) => {
      await deleteUser(id).then(() => {
        router.push({ name: "settings-users" });
      });
    };
    const onChangePasswordConfirmed = async (form) => {
      await changeUserPassword({ ...form, id: props.id });
      changePasswordModalVisible.value = false;
    };

    refreshUserData();
    return {
      deleteUser,
      onDelete,
      updateUser,
      userData,
      userLog,
      userFormSchema,
      changePasswordFormSchema,
      isUserModalOpen,
      loading,
      mainTitle,
      breadcrumbs,
      onChangePasswordConfirmed,
      changePasswordModalVisible,
      refreshUserData,
    };
  },
};
</script>

<style></style>
